var EnvNgApp;
(function (EnvNgApp) {
    var Core;
    (function (Core) {
        var Helpers;
        (function (Helpers) {
            var KendoHelper = /** @class */ (function () {
                function KendoHelper() {
                }
                KendoHelper.getModelFieldsDefinitions = function (obj) {
                    if (obj.id && obj.children && obj.hasChildren) {
                        return {
                            id: obj.id,
                            hasChildren: obj.hasChildren,
                            children: obj.children
                        };
                    }
                    if (obj.id && obj.fields) {
                        return {
                            id: obj.id,
                            fields: obj.fields
                        };
                    }
                    return null;
                };
                return KendoHelper;
            }());
            Helpers.KendoHelper = KendoHelper;
        })(Helpers = Core.Helpers || (Core.Helpers = {}));
    })(Core = EnvNgApp.Core || (EnvNgApp.Core = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=kendohelper.js.map